
import {getCarOne, getOrderCarOrderinfo, getPayQrcode, serveRecord} from "@/api/shenghuiHttp";
const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    ...offerColumn,
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "use_num",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];

const columnList: Array<column> = [
    // {
    //     prop: "ordersn",
    //     label: "单据编号",
    //     width: 66,
    // },
    {
        prop: "serve_time",
        label: "开单时间",
        width: 66,
    },
    {
        prop: "nickname",
        label: "接车人",
        width: 66,
    },
    {
        prop: "orderstatustext",
        label: "状态",
        width: 66,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 66,
    },
    {
        prop: "progress_text",
        label: "进度",
        width: 66,
    },
    {
        prop: "payment",
        label: "报价",
        width: 66,
    },
    {
        prop: "send_for_repair",
        label: "送修人",
        width: 66,
    },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 66,
    },
];
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { column } from "@/assets/types/common";
import { useRoute } from "vue-router";
export default defineComponent({
    name: "ServiceHistory",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["服务历史"]);
        //单据编号
        let detailData = reactive({
                dialogFormVisible: false,
                currentOrder: 0,
                detailTable: [] as Array<any>,
                orderDetail: {} as any,
                isProject: false,
                isMountings: false,
                carInfoDia_show:false,
                carInfoTable:[] as Array<any>,
        }),
            //车辆信息
            getCarInfo = ()=> {
                getCarOne({
                    car_id:detailData.orderDetail.car_id
                }).then((res:any)=>{
                    if (res.status == 200) {
                        detailData.carInfoDia_show = true;
                        let info = res.content.list;
                        if(info) {
                            let arr = [[
                                'VIN',
                                info.vin,
                                '品牌车型',
                                info.model_name,
                                '所属单位',
                                res.content.repairunit,
                                '车身颜色',
                                info.body_color,
                            ],[
                                '车主姓名',
                                info.master_name,
                                '车主手机',
                                info.car_master_phone,
                                '车主身份证',
                                info.idcard,
                                '发动机号',
                                info.engine_number,
                            ],[
                                '下次保养',
                                info.nm_time_text,
                                '保养里程',
                                info.maintenance_mileage,
                                '年检到期',
                                info.aidue_text,
                                '购车时间',
                                info.purchase_time_text,
                            ],[
                                '商业险到期',
                                info.ccidue_text,
                                '交强险到期',
                                info.compulsory_insurance_due_text,
                                '商业险公司',
                                info.cicompany_name,
                                '交强险公司',
                                info.jiompany_name,
                            ],[
                                '商业险保单号',
                                info.cipnumber,
                                '交强险保单号',
                                info.dipolicy_no,
                                '接车提示',
                                info.tips,
                            ]];
                            detailData.carInfoTable = arr;
                        }
                    }
                });
            },
            getSummaries = (param: any, type: number): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = detailData.orderDetail.project_sum_quoted_price;
                                } else {
                                    sums[index] = detailData.orderDetail.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = detailData.orderDetail.mountings_sum_output_value;
                                } else {
                                    sums[index] = detailData.orderDetail.mountings_sum_quoted_price;
                                }
                        
                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = detailData.orderDetail.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = detailData.orderDetail.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = detailData.orderDetail.settlement_pirce;
                                break;
                        }

                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击单据编号触发
            getOrderCarinfo = (order_id: number) => {
                detailData.currentOrder = order_id;
                getOrderCarOrderinfo({order_id}).then((res: any) => {
                    if (res.status == 200) {
                        detailData.dialogFormVisible = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ],[
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ],[
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ],[
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ],[
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '结算备注',
                                info.settlement_notes,
                            ]];
                            detailData.detailTable = arr;
                            detailData.orderDetail = res.content.list;
                            if (res.content.list.order_offer_project.length > 0) {
                                detailData.isProject = true
                            }
                            if (res.content.list.order_offer_mountings.length > 0) {
                                detailData.isMountings = true
                            }
                        }
                    }
                });
            };
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            headClass = inject("headClass"),
            route = useRoute(),
            getTableData = (): void => {
                loading.value = true;
                console.log(route.query)
                serveRecord({
                    page: currentPage.value,
                    page_size: pageSize.value,
                    car_id: route.query.car_id,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };

        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            total,
            pageSize,
            currentPage,
            getOrderCarinfo,
            detailData,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn,
            getSummaries,
            getCarInfo,
            handleSizeChange,
            handleCurrentChange
        };
    },
});
